import { GroupsWork } from "./components/PageGroups/Groups/GroupsWork";
import { HeaderGroups } from "./components/PageGroups/Header/Header";

export const Groups = () => {
    return (
      <div className="App">
          <HeaderGroups/>
          <GroupsWork/>
      </div>
    );
  } 
  
  